import { render, staticRenderFns } from "./AccountantStudents.vue?vue&type=template&id=572a2baa&scoped=true"
import script from "./AccountantStudents.vue?vue&type=script&lang=js"
export * from "./AccountantStudents.vue?vue&type=script&lang=js"
import style0 from "./AccountantStudents.vue?vue&type=style&index=0&id=572a2baa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572a2baa",
  null
  
)

export default component.exports